import authAxios, { authHeader } from "../data";
import qs from "qs";

const fetchData = async (customerId: string) => {
  const response = await authAxios.get(
    "/api/CustomersUsers?ParentId=" + customerId,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const removeItem = async (id: string) => {
  const response = await authAxios.delete(`/api/CustomersUsers/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (id: number, request: any) => {
  const response = await authAxios.put(`/api/CustomersUsers/${id}`, request, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchExistingUsers = async (search: string, customerId: string) => {
  const response = await authAxios.get("/api/CustomersUsers/Users", {
    params: { search, customerId },
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const create = async (request: any) => {
  const response = await authAxios.post("/api/CustomersUsers", request, {
    headers: authHeader(),
  });

  return response.data;
};

const CustomerPortalAccessesService = {
  fetchData,
  removeItem,
  update,
  fetchExistingUsers,
  create,
};

export default CustomerPortalAccessesService;
